import {DetailsList, IconButton, PrimaryButton} from "@fluentui/react";
import * as React from "react";
import {useEffect, useState, useContext} from "react";
import {SelectionMode} from "@fluentui/react";
import AppContent from "../Surfaces/AppContent";
import EditPerson from "../Panel/Person/EditPerson";
import AuthContext from "../Services/AuthContext";
import AddPerson from "../Panel/Person/AddPerson";
import {ChoiceGroup, Icon, SearchBox} from "@fluentui/react";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";
import MergePerson from "../Panel/Person/MergePerson";
import {Link, useOutletContext} from "react-router-dom";

function Person(props) {
    const [user] = useContext(AuthContext);
    const [persons, setPersons] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [filteredPersons, setFilteredPersons] = useState([]);
    const [filter, setFilter] = useState('marketing');
    const actions = useOutletContext();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/person", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setPersons(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editPerson, setEditPerson] = useState(false);
    const [addPerson, setAddPerson] = useState(false);
    const [mergePerson, setMergePerson] = useState(false);

    useEffect(() => {
        actions([
            {
                key: 'addPerson',
                text: 'Dodaj Osobę',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddPerson(true)
            }
        ]);
        return actions;
    }, []);

    const options = [
        { key: 'new', text: 'Nowe', iconProps: { iconName: 'People' } },
        { key: 'marketing', text: 'Marketing', iconProps: { iconName: 'FollowUser' } },
        { key: 'pre', text: 'Wstępny', iconProps: { iconName: 'TemporaryUser' } },
        { key: 'reserved', text: 'W trakcie', iconProps: { iconName: 'UserEvent' } },
        { key: 'sold', text: 'Sprzedane', iconProps: { iconName: 'UserFollowed' } },
    ];
    useEffect(() => {
        if (filter === 'new') {
             setFilteredPersons(persons.filter((item) => item.transactions_open === 0));
        } else if (filter === 'marketing') {
            setFilteredPersons(persons.filter((item) => item.transactions_open === 0 && item.marketing === 1));
        } else if (filter === 'pre') {
            setFilteredPersons(persons.filter((item) => item.transactions_open > item.reservations_closed));
        } else if (filter === 'reserved') {
            setFilteredPersons(persons.filter((item) => item.transactions_open > item.transactions_closed && item.transactions_open === item.reservations_closed));
        } else if (filter === 'sold') {
            setFilteredPersons(persons.filter((item) => item.transactions_open === item.transactions_closed && item.transactions_open > 0));
        } else {
            setFilteredPersons(persons.filter(item => whitespaceMatcher(filter, [item.name, item.surname, item.account_manager, item.keystring, item.projects].join(' '))));
        }

        return filteredPersons;
    }, [filter, persons]);

    const columns = [
        {
            key: 'name',
            name: 'Osoba',
            ariaLabel: 'Dane Osoby',
            fieldName: 'name',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
            isSorted: true,
            onRender: (item) => (<Link to={`/person/${item.id}`}><PrimaryButton text={`${item.name} ${item.surname}`}/></Link>)
        },
        {
            key: 'account_manager',
            name: 'Opiekun',
            ariaLabel: 'Opiekun Kontaktu',
            fieldName: 'account_manager',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: 'marketing',
            name: 'Marketing',
            ariaLabel: 'Zgoda Marketingowa',
            fieldName: 'marketing',
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            onRender: (item) => ( item.marketing ? <Icon iconName={'CheckMark'} title='Tak'/> : '')
        },
        {
            key: 'phone',
            name: 'Telefon',
            ariaLabel: 'Telefon Kontaktowy',
            fieldName: 'phone',
            minWidth: 70,
            isResizable: true,
        },
        {
            key: 'email',
            name: 'Email',
            ariaLabel: 'Email Kontaktowy',
            fieldName: 'email',
            minWidth: 150,
            isResizable: true,
        },
        {
            key: 'projects',
            name: 'Projekty',
            ariaLabel: 'Projekty kontaktu',
            fieldName: 'projects',
            minWidth: 150,
            maxWidth: 800,
            isResizable: true,
            isCollapsible: true
        },
        {
            key: 'keystring',
            name: 'Klucz',
            ariaLabel: 'Klucz porówniania w imporcie',
            fieldName: 'keystring',
            minWidth: 200,
            isResizable: false,
            isCollapsible: true
        },

        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'MergeDuplicate' }} title='Dołącz do' onClick={() => setMergePerson({id: item.id, persons: persons, keystring: item.keystring})}/>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditPerson(item)}/>
            </span>)
        }
    ];

    return (
        <AppContent title={'Osoby'}>
            <ChoiceGroup selectedKey={filter} options={options} onChange={(e, val) => setFilter(val.key)}/>
            <SearchBox placeholder="Wyszukaj" value={filter} onChange={(e, value) => setFilter(value)} />
            <DetailsList items={filteredPersons} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
            <EditPerson onSuccess={() => setRefresh(refresh + 1)} edit={editPerson} dismissPanel={() => setEditPerson(false)} />
            <AddPerson onSuccess={() => setRefresh(refresh + 1)} add={addPerson} dismissPanel={() => setAddPerson(false)} />
            <MergePerson onSuccess={() => setRefresh(refresh + 1)} edit={mergePerson} dismissPanel={() => setMergePerson(false)} />
        </AppContent>
    );
}

export default Person;